import {
    Button,
    Col,
    Form,
    InputNumber,
    Row,
    Select,
    Space,
    Switch,
} from 'antd'
import React from 'react'

import { CARD_TYPE_OPTIONS } from '@/modules/shraddha-shorts/constants'

interface CardFormProps {
    form: any
    onFinish: (values: any) => void
    onCancel: () => void
    isEditing: boolean
    submitting?: boolean
}

const CardForm: React.FC<CardFormProps> = ({
    form,
    onFinish,
    onCancel,
    isEditing,
    submitting = false,
}) => {
    return (
        <Form form={form} layout='vertical' onFinish={onFinish}>
            <Row gutter={16}>
                <Col span={24}>
                    <Form.Item
                        label='Card Type'
                        name='card_type'
                        rules={[{ required: true, message: 'Please select card type' }]}
                    >
                        <Select
                            placeholder='Select card type'
                            options={CARD_TYPE_OPTIONS}
                            disabled={isEditing}
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        label='Position'
                        name='position'
                        rules={[{ required: true, message: 'Please enter position' }]}
                    >
                        <InputNumber min={0} style={{ width: '100%' }} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label='Active' name='active' valuePropName='checked'>
                        <Switch />
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item>
                <Space>
                    <Button
                        type='primary'
                        htmlType='submit'
                        loading={submitting}
                        disabled={submitting}
                    >
                        {isEditing ? 'Update' : 'Create'}
                    </Button>
                    <Button onClick={onCancel} disabled={submitting}>
                        Cancel
                    </Button>
                </Space>
            </Form.Item>
        </Form>
    )
}

export default CardForm
